import axios from "axios";
import { configs } from "../app/app-configs";
import { Unit } from "./model/unit.model";

export const getUnits = async (): Promise<Unit[]> => {
    return await axios.get(`${configs.BASE_URL}/units`)
    .then(res => {
        return res.data as Unit[];
    });
}
 